import { type ComponentProps, type FunctionComponent } from 'react';
import cn from 'classnames';
import { HStack } from '@direct-frontend/components';
import styles from './GridHeaderRow.module.css';

export type GridHeaderRowProps = ComponentProps<typeof HStack> & { hasBottomBorder?: boolean };

export const GridHeaderRow: FunctionComponent<GridHeaderRowProps> = ({
    className,
    hasBottomBorder = true,
    ...props
}) => <HStack className={cn(styles.root, className, { [styles.borderBottom]: hasBottomBorder })} {...props} />;
